import { inject, InjectionToken } from "@angular/core";
import { KpiCommissionRoutePaths } from "@app/applications/dashboard/kpi-commission/kpi-commission-route-paths";
import { SideNavService } from "@shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";

/**
 * Sub-items of the Home entry: the home dashboard and the KPI commission dashboard.
 *
 * Once Home has children it opens a sub-panel, and it is shown only when at least one child is.
 */
export const HOME_SIDENAV_LINKS = new InjectionToken<void>("HOME_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    inject(SideNavService).addSubMenuItems("home", [
      {
        id: "home-dashboard",
        label: "SIDE_NAV.HOME.ITEMS.DASHBOARD",
        icon: "home",
        routerLink: "/",
        routerLinkExact: true,
        permissions: COMMON_GUARD_OPTIONS.HOME_DASHBOARD.VIEW.permissions,
      },
      {
        id: "kpi-commission",
        label: "SIDE_NAV.HOME.ITEMS.KPI_COMMISSION",
        icon: "wallet",
        routerLink: `${KpiCommissionRoutePaths.ROOT}${KpiCommissionRoutePaths.KPI_COMMISSION}`,
        permissions: COMMON_GUARD_OPTIONS.KPI_COMMISSION.VIEW.permissions,
      },
    ]);
  },
});
